module.exports = __webpack_public_path__ + "static/media/14UNEP17.8b562788.jpg";